import { Box } from '@leagueplatform/genesis-core';
import { Footer } from '@leagueplatform/solutions-foundation';
import { Disclaimer } from './disclaimer-section.component';
import { useAppFooterLinks } from './use-app-footer-links.hook';

export const AppFooter = () => {
  const { footerLinks, appDownloadLinks } = useAppFooterLinks();

  return (
    <Box css={{ marginTop: '$two' }}>
      <Footer
        backgroundColor="$surfaceBackgroundTertiary"
        textColor="$interactiveActionHovered"
        footerLinks={footerLinks}
        footerBody={<Disclaimer />}
        appDownloadIconLinks={appDownloadLinks}
      />
    </Box>
  );
};
